// @ts-nocheck
// Save Dashboard Filters
export const SAVE_DASHBOARD_FILTERS_REQUEST =
  "SAVE_DASHBOARD_FILTERS_REQUEST";
export const SAVE_DASHBOARD_FILTERS_SUCCESS =
  "SAVE_DASHBOARD_FILTERS_SUCCESS";
export const SAVE_DASHBOARD_FILTERS_FAILURE =
  "SAVE_DASHBOARD_FILTERS_FAILURE";

// Get Dashboard Filters
export const GET_DASHBOARD_FILTERS_REQUEST =
  "GET_DASHBOARD_FILTERS_REQUEST";
export const GET_DASHBOARD_FILTERS_SUCCESS =
  "GET_DASHBOARD_FILTERS_SUCCESS";
export const GET_DASHBOARD_FILTERS_FAILURE =
  "GET_DASHBOARD_FILTERS_FAILURE";

// Delete Dashboard Filters
export const DELETE_DASHBOARD_FILTERS_REQUEST =
  "DELETE_DASHBOARD_FILTERS_REQUEST";
export const DELETE_DASHBOARD_FILTERS_SUCCESS =
  "DELETE_DASHBOARD_FILTERS_SUCCESS";
export const DELETE_DASHBOARD_FILTERS_FAILURE =
  "DELETE_DASHBOARD_FILTERS_FAILURE";

// Update Dashboard Filters (Local State)
export const UPDATE_DASHBOARD_FILTERS = "UPDATE_DASHBOARD_FILTERS";